var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNameIdea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "idea-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.665,
    height: 23.578,
    viewBox: "0 0 26.665 23.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M12.182,6.058c-.258-.786-.469-1.667-.657-2.418H11.49c-.2.751-.387,1.655-.622,2.418l-1,3.181h3.321Z",
    transform: "translate(1.714 0.632)",
    fill: "#b7b7b7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M11.795,2.394h3.016l4.2,12.934H16.478L15.3,11.654h-4.1l-1.115,3.673H7.652L11.795,2.394ZM12.84,17.98l8.579,5.481a.745.745,0,0,0,.4.117.738.738,0,0,0,.434-.141.758.758,0,0,0,.293-.786l-1.2-4.671h2.159a3.168,3.168,0,0,0,3.157-3.169V3.157A3.166,3.166,0,0,0,23.508,0H2.594c.012.012.023.035.035.047A3.164,3.164,0,0,0,0,3.157V14.811A3.168,3.168,0,0,0,3.157,17.98Z",
    transform: "translate(0 0)",
    fill: "#b7b7b7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIdea);
export default __webpack_public_path__ + "static/media/name-idea.9a246a29ec758e58424ded41837457f5.svg";
export { ForwardRef as ReactComponent };